document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".addson-wrapper").forEach((wrapper) => {
        const openDrawerButton = wrapper.querySelector(".mattress-drawer-open-btn"),
            mattressDrawer = wrapper.querySelector(".mattress-drawer"),
            overlay = wrapper.querySelector(".mattress-drawer-overlay"),
            closeDrawerButton = wrapper.querySelector(".mattress-drawer-close-btn"),
            headerElement = document.querySelector('.shopify-section-group-header-group.section-header-navigation.shopify-section-header-sticky'),
            productOptions = wrapper.querySelectorAll(".mattress-drawer-service-option"),
            sizeTabs = wrapper.querySelectorAll(".only-variants .mattress-drawer-variant-tab"),
            // selectedSizeElement = document.querySelector(".selected-option.size"),
            addToBasketButton = wrapper.querySelector(".mattress-drawer-add-to-basket"),
            addToBasketBtn = wrapper.querySelector(".add-to-basket-btn");

        addToBasketButton.style.display = "none";

        function openDrawer() {
            mattressDrawer.classList.add("active");
            overlay.classList.add("active");
            document.body.classList.add("no-scroll");
            if (headerElement) {
                headerElement.style.setProperty('z-index', '2', 'important');
            }
            addToBasketButton.style.display = "none";
            productOptions.forEach(opt => {
                opt.querySelector("label").classList.remove("selected");
            });
        }

        function closeDrawer() {
            mattressDrawer.classList.remove("active");
            overlay.classList.remove("active");
            document.body.classList.remove("no-scroll");
            if (headerElement) {
                headerElement.style.removeProperty('z-index');
            }
        }

        openDrawerButton?.addEventListener("click", openDrawer);
        closeDrawerButton?.addEventListener("click", closeDrawer);
        overlay?.addEventListener("click", closeDrawer);

        function getSelected(tabGroup) {
            if (!tabGroup) return {};
            const selected = tabGroup.querySelector('[aria-selected="true"]');
            return selected ? selected.dataset : {};
        }

        function formatSize(size) {
            // Remove any single quotes, double quotes, and replace spaces with hyphens
            return size
                .replace(/['"]/g, '')
                .replace(/\s+/g, '-')
                .toLowerCase();
        }
        function getSelectedSizeValue() {
            const checked = document.querySelector('input[type="radio"][name*="Size"]:checked');
            return checked ? checked.value.trim() : "";
        }
        function filterProducts() {
            const selectedSizeRaw = getSelectedSizeValue();
            const selectedSize = selectedSizeRaw ? formatSize(selectedSizeRaw) : "";
            // console.log("Selected Size: ", selectedSize);
            let selectedMetafield = "";
            const metafieldTabGroup = document.querySelector(".metafield-tabs");
            if (metafieldTabGroup) {
                selectedMetafield = getSelected(metafieldTabGroup).metafield || "";
            }

            const selectedHeight = getSelected(document.querySelector(".variant-metafield-for-height")).variantHeight || "";
            const selectedButton = getSelected(document.querySelector(".variant-metafield-for-button")).variantButton || "";

            productOptions.forEach((option) => {
                const size = option.getAttribute("data-variant") || "";
                const metafield = option.getAttribute("data-metafield") || "";
                const height = option.getAttribute("data-variant-height") || "";
                const button = option.getAttribute("data-variant-button") || "";

                const matchSize =
                    !selectedSize || !size || selectedSize === size;

                const matchMetafield =
                    !selectedMetafield || !metafield || selectedMetafield === metafield;

                const matchHeight =
                    !selectedHeight || !height || selectedHeight === height;

                const matchButton =
                    !selectedButton || !button || selectedButton === button;

                option.style.display =
                    matchSize && matchMetafield && matchHeight && matchButton
                        ? "block"
                        : "none";
            });
        }

        function setupTabs(tabGroupSelector, preselect = true, resetOnClickSelector = "") {
            const tabs = document.querySelectorAll(`${tabGroupSelector} .mattress-drawer-metafield-tab`);
            if (!tabs.length) return;

            tabs.forEach((tab, index) => {
                if (preselect && index === 0) {
                    tab.setAttribute("aria-selected", "true");
                    tab.classList.add("active");
                } else {
                    tab.setAttribute("aria-selected", "false");
                    tab.classList.remove("active");
                }

                tab.addEventListener("click", function () {
                    tabs.forEach((t) => {
                        t.setAttribute("aria-selected", "false");
                        t.classList.remove("active");
                    });
                    this.setAttribute("aria-selected", "true");
                    this.classList.add("active");

                    if (resetOnClickSelector) {
                        const resetTabs = document.querySelectorAll(`${resetOnClickSelector} .mattress-drawer-metafield-tab`);
                        resetTabs.forEach((rt) => {
                            rt.setAttribute("aria-selected", "false");
                            rt.classList.remove("active");
                        });
                    }

                    filterProducts();
                });
            });
        }


        setupTabs(".only-variants"); // size
        if (document.querySelector(".metafield-tabs")) {
            setupTabs(".metafield-tabs");
        }
        setupTabs(".variant-metafield-for-height", true, ".variant-metafield-for-button"); // height resets button
        setupTabs(".variant-metafield-for-button", false); // no preselect for button

        document.addEventListener("change", function (e) {
            if (e.target.matches('input[type="radio"][name*="Size"]')) {
                syncSelectedSizeToTabs();
            }
        });

        function syncSelectedSizeToTabs() {
            const sizeText = getSelectedSizeValue();

            if (!sizeText) return;

            sizeTabs.forEach((tab) => {
                const tabSize = tab.dataset.variant?.trim();
                const isMatch = tabSize === sizeText;

                tab.setAttribute("aria-selected", isMatch ? "true" : "false");
                tab.classList.toggle("active", isMatch);
            });

            filterProducts(); // Re-run the filter after size change
        }

        syncSelectedSizeToTabs();
        filterProducts();

        productOptions.forEach((option) => {
            option.addEventListener("click", function () {
                addToBasketButton.style.display = "block";
                const label = option.querySelector("label");
                productOptions.forEach((opt) => {
                    opt.querySelector("label").classList.remove("selected");
                });
                label.classList.add("selected");

                filterProducts();
            });
        });

        addToBasketBtn.addEventListener("click", function () {
            const selectedProduct = document.querySelector(".mattress-drawer-service-option input:checked");

            if (selectedProduct) {
                const productVariantId = selectedProduct.getAttribute("data-variant-id");
                const mainProductTitle = selectedProduct.getAttribute("data-main-product-title");
                const productTitle = selectedProduct.getAttribute("data-product-title");
                const productPrice = selectedProduct.getAttribute("data-product-price");
                const productSavePrice = selectedProduct.getAttribute("data-product-save-price");
                const productComparePrice = selectedProduct.getAttribute("data-product-compare-price");
                const productImage = selectedProduct.getAttribute("data-product-icon");
                const productLink = selectedProduct.getAttribute("data-product-url");
                const productSize = selectedProduct.getAttribute("data-variant-title");
                const productVariantLabel = selectedProduct.getAttribute("data-variant-label") || "";
                const productVariantQuantity = selectedProduct.getAttribute("data-variant-quantity") || "";

                const data = {
                    items: [{
                        id: productVariantId,
                        quantity: 1,
                        properties: {
                            "Product Code": productVariantLabel,
                            "Product Parts": productVariantQuantity,
                            "Match With": mainProductTitle
                        }
                    }],
                };

                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        closeDrawer();

                        const addButtonDiv = wrapper.querySelector(".addson-main-button-div");

                        addButtonDiv.innerHTML = `
                        <div class="selected-product-show-main">
                            <div class="selected-product-show">
                                <input type="hidden" name="addson" id="addson-product" value="${productTitle}"
                                    data-product-name="${productTitle}" data-product-image="${productImage}"
                                    class="custom-product-option product-form__radio">
                                <div class="addsoon_products_icon">
                                    <img src="${productImage}" alt="${productTitle}" loading="lazy" width="100" height="100">
                                </div>
                                <div class="addsoon_products_title">
                                    <h4>${productTitle}</h4>
                                    <span class="main-comp-price for-desktop">
                                        <span class="price-current">${productPrice}</span>
                                        ${productComparePrice
                                                        ? `<span class="save-comp">
                                            <span class="price-compare">${productComparePrice}</span>
                                            <span class="price-save">Save: ${productSavePrice}</span>
                                        </span></span>
                                    <span class="selected-size for-desktop">${productSize}</span>` : ""
                                                    }
                                </div>
                            </div>
                            <div class="main-btn-price-size">
                                <div class="for-mobile price-size">
                                    <span class="main-comp-price">
                                        <span class="price-current">${productPrice}</span>
                                        ${productComparePrice
                                                        ? `<span class="save-comp">
                                            <span class="price-compare">${productComparePrice}</span>
                                            <span class="price-save">Save: ${productSavePrice}</span>
                                        </span></span>
                                    <span class="selected-size">${productSize}</span>` : ""
                                                    }
                                </div>
                                <button id="change-product-btn" class="change-product-btn" data-variant-id="${productVariantId}">Change</button>
                            </div>
                        </div>
                        `;
                        const changeButton = wrapper.querySelector(".change-product-btn");
                        changeButton.addEventListener("click", function () {
                            const addButtonDiv = wrapper.querySelector(".addson-main-button-div");

                            productOptions.forEach((opt) => {
                                opt.querySelector("label").classList.remove("selected");
                            });

                            fetch(`/cart/change.js`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    id: productVariantId,
                                    quantity: 0,
                                }),
                            })
                                .then((response) => response.json())
                                .then((data) => {
                                    addButtonDiv.innerHTML = `
                  <div class="addsoon_products_icon">
                    <img src="${productImage}" alt="${productTitle}" loading="lazy">
                  </div>
                  <div class="addsoon_products_title">
                    <h4>${productTitle}</h4>
                  </div>
                  <button class="mattress-drawer-open-btn" aria-haspopup="dialog" aria-controls="mattress-drawer" aria-expanded="false">
                    ${buttonText}
                  </button>
                `;
                                    const openDrawerButton = wrapper.querySelector(".mattress-drawer-open-btn");
                                    if (openDrawerButton) {
                                        openDrawerButton.addEventListener("click", openDrawer);
                                    }
                                    openDrawer();
                                })
                                .catch((error) =>
                                    console.error("Error removing product from cart:", error)
                                );
                        });
                    })
                    .catch((error) =>
                        console.error("Error adding product to cart:", error)
                    );
            }
        });
    });
});
